export default __webpack_public_path__ + "/dist/images/3034080.png";